export const environment = {
  production: true,
  env: 'production',
  cdnPath: 'https://cdn.gohenry.com/blog',
  domain: 'gohenry.com',
  website: 'https://www.gohenry.com/uk/',
  webapp: 'https://app.gohenry.com/uk/',
  location: 'https://www.gohenry.com/uk/blog/',
  root: 'https://www.gohenry.com/uk/blog/',
  signup: 'https://signup.gohenry.com/uk',
  socialCampaign: false,
  socialImage: 'https://cdn.gohenry.com/blog/develop/blog-social-default.png',
  jsonImage: 'https://cdn.gohenry.com/site-furniture/amp-uk/images/gohenry.png',
  homeMetaTitle: 'The ultimate kids\' debit card and financial education app',
  support: 'https://uk.community.gohenry.com/s/',
  apiUrl: 'https://blog-uk.gohenry.com',
  newsletter: 'https://www.gohenry.com/uk/newsletter',
  blogMicroService: '',
  debug: false,
  locale: 'en-gb',
  country: 'uk',
  gtm: 'GTM-5GTFS9M',
  cookieConsent: {
    scriptUrl: `https://cdn-ukwest.onetrust.com/consent/019f3767-7251-7f4a-8c73-547e19ced5c8/otSDKStub.js`,
    dataDomainScript: '019f3767-7251-7f4a-8c73-547e19ced5c8',
    autoBlockScript: '',
    targetingGroupId: 'C0004',
  },
};
